export class Populations {
  public static Default = 'Default';
  public static RewardsTest = 'Rewards Test';
  public static GuardianTest = 'Guardian Test';
  public static ChildTest = 'Child Test';
}
